import { useLocale } from "@calcom/lib/hooks/useLocale";
import { Icon } from "@calcom/ui/components/icon";

export const SlotsLoadError = () => {
  const { t } = useLocale();

  return (
    <div
      data-testid="slots-load-error"
      className="col-span-7 row-span-6 flex aspect-[7/6] flex-col items-center justify-center gap-3 text-center">
      <Icon name="circle-alert" className="text-error h-10 w-10" />
      <p className="text-emphasis max-w-[16rem] text-sm font-semibold">{t("could_not_load_dates")}</p>
      <p className="text-subtle max-w-[16rem] text-sm">{t("please_try_again_later")}</p>
    </div>
  );
};

export default SlotsLoadError;
